import { v4 as uuid } from 'uuid';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

class SubBlockTextData {
  id: string;
  title?: BlockComponentText;
  text?: BlockComponentText;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace SubBlockTextData {
  export function make(title?: string, text?: string): SubBlockTextData {
    return {
      id: uuid(),
      title: title ? BlockComponentText.make(title) : undefined,
      text: text ? BlockComponentText.make(text) : undefined,
    };
  }

  export function getDefault(title = 'タイトル', text = '説明'): SubBlockTextData {
    return make(
      `<h2>${title}</h2>`,
      `<p>${text}</p>`,
    );
  }
}

export default SubBlockTextData;
